/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Dashboard
 *| (C) Copyright IBM Corp. 2018, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */

import $ from 'jquery';
import _ from 'underscore';
const Toolbar = require('gemini/lib/@waca/dashboard-common/dist/ui/AuthoringToolbar');

export default class ToolbarHelper {
	/**
	 * The ToolbarHelper is is designed to hide common jquery authoring toolbar code
	 * for things like the filter dialog or the slot action menu.
	 */
	constructor() {}

	getToolbar() {
		return this._actionMenuToolbar;
	}

	/**
	 * build an action toolbar based on dashboard authoring toolbar class.
	 * @param aActions - the actions to be added to the toolbarRoot
	 * @param parentNode - the parentNode that contains the toolbar.
	 * @param label - a label for the toolbar
	 * @param userOptions - options such as placement and the attachPoint (class of the node where the toolbar will live)
	 */
	buildActionToolbar(aActions, parentNode, sLabel, userOptions) {
		var toolbarOptions = _.clone(userOptions);
		toolbarOptions.textOnly = true;
		toolbarOptions.flyoutClass = 'popover actionToolbarPopover text';

		this.$parentNode = $(parentNode);
		this.$parentNode.addClass('action-menu-opened');

		//We expect to find a div with this class under the parent to root the menu at (by default, the className is menuroot )
		const $attachPoint = this.$parentNode.find((userOptions.attachPoint) || '.toolbarRoot');

		var toolbar = new Toolbar(toolbarOptions);
		toolbar.setName(sLabel);
		toolbar.addItems(aActions);
		toolbar.setSelectionContext([$attachPoint]);
		toolbar.show(toolbarOptions.placement);

		// This event is triggered only when user clicks away or press Escape to hide the toolbar.
		// We refresh the UI after that.
		// Other events like onPopupClose and bspopover.hidden are called when toolbar is changed.
		toolbar.on('flyout:hide', this.removeToolbar, this);
		toolbar.on('toolbar:remove', this.onToolbarRemove.bind(this));

		this._actionMenuToolbar = toolbar;
	}

	removeToolbar() {
		if (this._actionMenuToolbar) {
			//Passing true to request the 'toolbar:remove' to trigger
			this._actionMenuToolbar.remove(true /* triggerEvent */);
		}
	}

	//Default implementation when the toolbar is removed.
	//A user can override this to perform some specific action at remove time in the arguments.
	onToolbarRemove() {
		if(this.$parentNode) {
			this.$parentNode.removeClass('action-menu-opened');
			this.$parentNode = null;
		}
		if (this._actionMenuToolbar) {
			this._actionMenuToolbar = null;
		}
	}
}



// WEBPACK FOOTER //
// ./src/js/ToolbarHelper.js